import { render, staticRenderFns } from "./WrapperQrTickets.vue?vue&type=template&id=9c64c6c0"
import script from "./WrapperQrTickets.vue?vue&type=script&lang=js"
export * from "./WrapperQrTickets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports